import {
  SET_COURSES_STATUS,
  SET_COURSES_TYPE,
  SET_COURSES_CATEGORY,
  SET_COURSES_TEACHER,
  SET_COURSES_HOT,
  SET_COURSES_LEVEL,
  SET_COURSES_FACULT
} from '@/store/mutation-types'

const changeSearchCoursesStatus = ({commit, dispatch}, payload) => {
  commit(SET_COURSES_STATUS, payload)
}
const changeSearchCoursesType = ({commit, dispatch}, payload) => {
  commit(SET_COURSES_TYPE, payload)
}
const changeSearchCoursesCategory = ({commit, dispatch}, payload) => {
  commit(SET_COURSES_CATEGORY, payload)
}
const changeSearchCoursesTeacher = ({commit, dispatch}, payload) => {
  commit(SET_COURSES_TEACHER, payload)
}
const changeSearchCoursesHot = ({commit, dispatch}, payload) => {
  commit(SET_COURSES_HOT, payload)
}
const changeSearchCoursesLevel = ({commit, dispath}, payload) => {
  commit(SET_COURSES_LEVEL, payload)
}
const changeSearchCoursesFacult = ({commit, dispath}, payload) => {
  commit(SET_COURSES_FACULT, payload)
}

export default {
  changeSearchCoursesStatus,
  changeSearchCoursesType,
  changeSearchCoursesCategory,
  changeSearchCoursesTeacher,
  changeSearchCoursesHot,
  changeSearchCoursesLevel,
  changeSearchCoursesFacult
}



// WEBPACK FOOTER //
// ./src/components/courses/store/actions.js